












































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import { maskCPFCNPJ, maskDate } from '@/utils/common'
import RecebimentoStore from '@/components/Recebimento/Store/RecebimentoStore'
import ModalAddGestores from './ModalAddGestores.vue'

@Component({
  components: {
    ModalAddGestores,
  },
})
export default class ModalGestores extends Vue {
  readyState: boolean = false
  loadGestores: boolean = false
  loadModalAddGestor: boolean = false
  loadEditHospital: string = ''
  gestorSearch: string = ''

  get getRecebimentoStore() { return getModule(RecebimentoStore, this.$store) }

  get getGestores() { return this.getRecebimentoStore.contratoGestores }

  get loadingShowModalAddGestor() { return this.loadModalAddGestor }
  set loadingShowModalAddGestor(value: boolean) { this.loadModalAddGestor = value }

  get loadingEditHospital() { return this.loadEditHospital }
  set loadingEditHospital(value: string) { this.loadEditHospital = value }

  get loadingGestores() { return this.loadGestores }
  set loadingGestores(value: boolean) { this.loadGestores = value }

  get getGestoresTableHeader() {
    return [
      { text: 'Nome', class: 'table-headers', align: 'left', value: 'nome' },
      { text: 'Cadastro por gestor ?', class: 'table-headers', align: 'left', value: 'cnpj' },
      { text: 'Criado em', class: 'table-headers', align: 'left', value: 'nomeGrupo' },
      { text: 'Ações', class: 'table-headers', value: '', align: 'center', sortable: false },
    ]
  }

  get showModalGestores() {
    return this.getRecebimentoStore.modalGestores
  }

  set showModalGestores(value: boolean) {
    this.getRecebimentoStore.setModalGestores(value)
  }

  maskCnpj(cnpj: string) {
    return maskCPFCNPJ(cnpj)
  }

  maskDate(date: string) {
    return maskDate(date)
  }

  showEventBus() {
    EventBus.$emit('setSnackbar', {
      show: true,
      text: 'Somente gestores incluídos por essa tela podem ser removidos.',
      icon: 'warning',
      color: '#C62828',
    })
  }

  async showModalAddGestor() {
    this.loadingShowModalAddGestor = true
    this.getRecebimentoStore.setModalAddGestores(true)
    this.loadingShowModalAddGestor = false
  }

  async deletarGestor(id: string) {
    this.loadingEditHospital = id
    const request = await this.getRecebimentoStore.removeContratoGestor(id)
    if (request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Gestor removido com sucesso!',
        icon: 'check',
        color: '#43A047',
      })
      this.getRecebimentoStore.setContratoGestores(this.getRecebimentoStore.contratoGestores.filter((gestor: any) => gestor.id !== id))
      this.loadingEditHospital = ''
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
      icon: 'warning',
      color: '#C62828',
    })
    this.loadingEditHospital = ''
  }

  @Watch('showModalGestores')
  onChangeShowModalGestores(value: boolean) {
    if (!value) {
      this.getRecebimentoStore.getDadosContratoEGestores()
    }
  }
}
